import React from "react";
import PropTypes from "prop-types";
import { Media } from "components/Media";
import cn from "classnames";
import css from "./HighlightedProjectBlock.module.scss";
import Button from "components/Button";
import Icon from "components/Icon";
import { presentDomain } from "utils";
import OnScreen from "components/OnScreen";

class HighlightedProjectBlock extends React.Component {
    static propTypes = {
        onScreen: PropTypes.bool,
        blockId: PropTypes.number,
        inList: PropTypes.bool,
        heading: PropTypes.string,
        useExternalUrl: PropTypes.bool.isRequired,
        view: PropTypes.oneOf(["default", "grid", "list"]).isRequired,
        project: PropTypes.shape({
            text: PropTypes.string,
            externalUrl: PropTypes.string,
            link: PropTypes.string,
            heading: PropTypes.string,
            backgroundImage: Media && Media.propTypes.image,
            backgroundImageAlt: PropTypes.string,
        }),
    };

    static defaultProps = {
        useExternalUrl: false,
        view: "default",
    };

    render() {
        const {
            onScreen,
            useExternalUrl,
            blockId,
            inList,
            heading,
            view,
            project,
        } = this.props;

        let Component = "a";
        if (useExternalUrl) {
            Component = "div";
        }

        return heading || project ? (
            <div
                className={cn(css.block, {
                    [css.inList]: inList,
                })}
                data-block={blockId}
            >
                {heading && !inList && (
                    <h2 className="block-title-large">{heading}</h2>
                )}
                {project && (
                    <Component
                        className={cn(css.imageArea, {
                            [css["is-on-screen"]]: onScreen,
                        })}
                        data-block={blockId}
                        href={Component === "a" && project.link}
                    >
                        <div className={css.inner}>
                            <div className={css.imageWrapper}>
                                {/* BE: Image recommended size is 1180x470px */}
                                <Media
                                    className={css.image}
                                    image={project.backgroundImage}
                                    alt={
                                        project.backgroundImageAlt
                                            ? project.backgroundImageAlt
                                            : ""
                                    }
                                />

                                <div className={css.textContent}>
                                    {project.heading && (
                                        <h2 className={css.projectHeading}>
                                            {project.heading}
                                        </h2>
                                    )}
                                    {view === "default" && project.text && (
                                        <p className={css.text}>
                                            {project.text}
                                        </p>
                                    )}
                                    <div className={css.button}>
                                        {useExternalUrl && project.externalUrl && (
                                            <Button href={project.externalUrl}>
                                                {presentDomain(
                                                    project.externalUrl
                                                )}
                                                <Icon
                                                    className={cn(
                                                        css.icon,
                                                        css.darkgray
                                                    )}
                                                    icon="share"
                                                />
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Component>
                )}
            </div>
        ) : null;
    }
}

export default OnScreen(HighlightedProjectBlock);



// WEBPACK FOOTER //
// ./src/components/HighlightedProjectBlock/HighlightedProjectBlock.jsx